import {BaseApiTemplateService, Core2Config} from '../../shared';
import {AutoDebitTxnContainerModel, FinancialItemMarketplaceContainerModel} from '../../../../../../models';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({providedIn: 'root'})
export class AutoDebitTxnService extends BaseApiTemplateService<AutoDebitTxnContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity/autodebit-txns/backoffice-ep';
    this.endpoint_path =  Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity/autodebit-txns/backoffice-ep';
    this.httpClient = http;
  }

}
